// extracted by mini-css-extract-plugin
export default {"teamInfoContainer":"TournamentInfo_teamInfoContainer__jAvN2","teamInfoContainerLink":"TournamentInfo_teamInfoContainerLink__0u6oK"};